import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Policy Area: A grouping of related company policies (e.g. People & Workplace, Everyday Security), and Policy: A single company policy document.',
    name: 'Policies',
    partialId: PartialId.Standard.create('policies'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
